<script setup lang="ts">
import { normalizeTrafficSourceCosts } from '@/utils/trafficSourceCostsUtils'
import { getCurrencySymbol } from '@/utils/helper'
import type { TrafficSourceCostsGroupType, TrafficSourceCostsServerType } from '@/types/trafficSourceCosts'
import { computed } from 'vue'
import FlexComponent from '@/ui-library/atoms/FlexComponent/FlexComponent.vue'
import InstagramIcon from '@/assets/icons/instagram.svg?component'
import TikTokIcon from '@/assets/icons/tiktok.svg?component'
import LinkIcon from '@/assets/icons/link.svg?component'
import SnapchatIcon from '@/assets/icons/snapchat.svg?component'

const sourceImagesMap = {
  0: LinkIcon,
  1: InstagramIcon,
  2: TikTokIcon,
  3: SnapchatIcon,
}
const props = withDefaults(
  defineProps<{ isBoldLabel?: boolean; isBoldValue?: boolean; currency: string; trafficSourcesCosts: TrafficSourceCostsServerType[] }>(),
  {
    trafficSourcesCosts: () => [],
  },
)
const currencySymbol = computed(() => getCurrencySymbol(props.currency))
const groups = computed<TrafficSourceCostsGroupType[]>(() => normalizeTrafficSourceCosts(props.trafficSourcesCosts))
const cpcGroup = computed(() => groups.value.filter((item: TrafficSourceCostsGroupType) => item.rateCpc > 0))
const cpaGroup = computed(() => groups.value.filter((item: TrafficSourceCostsGroupType) => item.rateCpa > 0))
</script>
<template>
  <flex-component direction="column" class="costs-data-row__container" :gap="8">
    <flex-component v-if="cpcGroup.length" :gap="4" align="center" wrap="wrap" class="costs-data-row__content">
      <span :class="{ 'costs-data-row__content-bold': isBoldLabel }">CPC:</span>
      <flex-component
        v-for="(item, index) in cpcGroup"
        :key="item.id"
        :gap="4"
        align="center"
        :class="{ 'costs-data-row__content-bold': isBoldValue }"
      >
        <flex-component v-for="source in item.sourceIndexes" :key="source" :gap="2">
          <el-icon :size="24">
            <component :is="sourceImagesMap[source]" />
          </el-icon>
        </flex-component>
        {{ `${item.rateCpc} ${currencySymbol}${index + 1 < cpcGroup.length ? ', ' : ''}` }}
      </flex-component>
    </flex-component>
    <flex-component v-if="cpaGroup.length" :gap="4" align="center" wrap="wrap" class="costs-data-row__content">
      <span :class="{ 'costs-data-row__content-bold': isBoldLabel }">CPA:</span>
      <flex-component
        v-for="(item, index) in cpaGroup"
        :key="item.id"
        :gap="4"
        align="center"
        :class="{ 'costs-data-row__content-bold': isBoldValue }"
      >
        <flex-component v-for="source in item.sourceIndexes" :key="source" :gap="2">
          <el-icon :size="24">
            <component :is="sourceImagesMap[source]" />
          </el-icon>
        </flex-component>
        {{ `${item.rateCpa}%${index + 1 < cpaGroup.length ? ', ' : ''}` }}
      </flex-component>
    </flex-component>
  </flex-component>
</template>
<style lang="scss" scoped>
.costs-data-row__container {
  &:deep(* + *) {
    margin-top: initial;
  }
}
.costs-data-row__content {
  font-size: inherit;
  line-height: inherit;
}
.costs-data-row__content-bold {
  font-weight: bold;
}
</style>
